<div *ngIf="error" class="error">
  {{ error }}
</div>

<div fxLayout="column" *ngIf="token; else noToken">
  {{ token }}
</div>

<ng-template #noToken>
  <div class="w-100-vw h-100-vh d-flex flex-column justify-content-center align-items-center">
    <img src="/assets/images/logos/myspot_logo.svg" alt="myspot" style="width: 120px; height: 120px" />
    <button *ngIf="!isAuthenticated" class="cta-btn cta-primary" role="button" (click)="login()">Login</button>
    <p *ngIf="isAuthenticated && userName">Await redirection...</p>
  </div>
</ng-template>
